module.exports = __webpack_public_path__ + "static/media/cars.cb0e5383.svg";